import React, { Component } from 'react';

import DaykaLogo from '../assets/daykalogogrande.png';
import FotoEmpresa1 from '../assets/empresa-01.jpg';
import FotoEmpresa2 from '../assets/empresa-02.jpg';


class PageEmpresa extends Component {
  render() {
    return (
      <div id="body">

        <img src={DaykaLogo} id="body-logo" />

        <h1 id="body-h1"> Empresa</h1>

        <p>
          A Dayka foi fundada em 2001, se desenvolveu no ritmo da agricultura nacional com a comercialização de sementes forrageiras com a marca Brazil Seeds e a venda de big bags. Hoje tem clientes em todas unidades federativas do Brasil e no exterior.
        </p>

        <br /><br />
        <div id="div-img-localizacao">
          <img src={FotoEmpresa2} />
          <img src={FotoEmpresa1} />
        </div>

      </div>
    );
  }
}

export default PageEmpresa;



// WEBPACK FOOTER //
// ./src/Pages/PageEmpresa.js